export const colors: Record<string, string> = {
  appBarBackground: "#040548",
  mainBlue: "#1E88E5",
  halfTransparentBlue: "#8081A4",
  separatorBlue: "#1B1B58",
  lightBlue: "#4A4B7B",
  defaultWhite: "#FFFFFF",
  defaultBlack: "#3D3D3D",
  errorRed: "#FF6060",
  activeGreen: "#00CC8C",
  paleBlue: "#8687A8",
};
